import React, { useState } from "react";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const handleSectionClick = (sectionId) => {
    if (location.pathname === '/') {
      // Si estamos en la home, hacer scroll directamente
      document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
    } else {
      // Si estamos en otra página, navegar a home con hash
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <nav className="relative z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-lg">I2M</span>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-semibold text-gray-800">
                  Innova2Market
                </span>
                <div className="flex items-center space-x-1 text-xs text-gray-500">
                  <span>Powered by</span>
                  <img 
                    src="/agiliacenter-logo.webp" 
                    alt="AgiliaCenter - Desarrollado por AgiliaCenter" 
                    className="h-3 opacity-70"
                  />
                </div>
              </div>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <Button
              variant="ghost" 
              className="text-gray-600 hover:text-gray-900 transition-colors"
              onClick={() => handleSectionClick('servicios')}
            >
              Servicios
            </Button>
            <Button
              variant="ghost"
              className="text-gray-600 hover:text-gray-900 transition-colors"
              onClick={() => handleSectionClick('ecommerce')}
            >
              Ecommerce
            </Button>
            <Button
              variant="ghost"
              className="text-gray-600 hover:text-gray-900 transition-colors"
              onClick={() => handleSectionClick('integraciones')}
            >
              Integraciones
            </Button>
            <Button
              variant="ghost"
              className="text-gray-600 hover:text-gray-900 transition-colors"
              onClick={() => handleSectionClick('proceso')}
            >
              Proceso
            </Button>
            <Button
              variant="outline"
              className="border-purple-200 text-purple-600 hover:bg-purple-50 transition-colors"
              onClick={() => window.open('https://cal.com/peter-gal/30min?overlayCalendar=true', '_blank')}
            >
              Consulta Gratuita
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-600 hover:text-gray-900"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden absolute top-20 left-0 right-0 bg-white shadow-lg border-t border-gray-100">
            <div className="px-6 py-4 space-y-4">
              <Button 
                variant="ghost" 
                className="w-full justify-start text-gray-600"
                onClick={() => {
                  handleSectionClick('servicios');
                  setIsMenuOpen(false);
                }}
              >
                Servicios
              </Button>
              <Button 
                variant="ghost" 
                className="w-full justify-start text-gray-600"
                onClick={() => {
                  handleSectionClick('ecommerce');
                  setIsMenuOpen(false);
                }}
              >
                Ecommerce
              </Button>
              <Button 
                variant="ghost" 
                className="w-full justify-start text-gray-600"
                onClick={() => {
                  handleSectionClick('integraciones');
                  setIsMenuOpen(false);
                }}
              >
                Integraciones
              </Button>
              <Button 
                variant="ghost" 
                className="w-full justify-start text-gray-600"
                onClick={() => {
                  handleSectionClick('proceso');
                  setIsMenuOpen(false);
                }}
              >
                Proceso
              </Button>
              <Button 
                variant="outline" 
                className="w-full border-purple-200 text-purple-600"
                onClick={() => window.open('https://cal.com/peter-gal/30min?overlayCalendar=true', '_blank')}
              >
                Consulta Gratuita
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;